enum FileTypes {
  SVG = "image/svg+xml",
  PNG = "image/png",
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PJPEG = "image/pjpeg",
  CSV = "text/csv",
}

export default FileTypes;
